import React from 'react';

import { ColorSchema, FontSize, FontWeight } from '../../../typings/design-tokens';
import { MatchStatusType } from '../../../typings/match';
import { getFooterData, IFooter } from '../../../utils/match-header-footer';
import {
  computeFullTime,
  isEnded,
  isEndedAfterOverTime,
  isEndedAfterShootout,
  isLive,
} from '../../../utils/match-status';
import { IMatchRow } from '../match-row/match-row';
import Team, { IconPosition, TeamLogoSize } from '../team/team';

// DEFAULT COLORS/SIZES
const DEFAULT_TEAM_COLOR_SCHEMA: ColorSchema = 'dark';
const DEFAULT_TEAM_ICON_POSITION: IconPosition = 'left';
const DEFAULT_TEAM_LOGO_SIZE: TeamLogoSize = '20';
const DEFAULT_TEAM_TEXT_FONT_SIZE: FontSize = '14';
const DEFAULT_TEAM_TEXT_FONT_WEIGHT: FontWeight = '400';

export const getGoalByStatus = (goal: number | '-' | undefined, status: MatchStatusType): number | '-' =>
  isLive(status) || isEnded(status) ? goal ?? '-' : '-';

// Calc DS/DCR/TOT
export const getGoalsText = (match: IMatchRow): string => {
  const matchFullTime: IMatchRow = computeFullTime(match); // Adds "FullTimeAfterOverTime" or "FullTimeAfterShootOut"
  const { competitionPhase, competitionPhaseRound, status, away, home } = matchFullTime;
  const goals: IFooter = getFooterData({ competitionPhase, competitionPhaseRound, status, away, home }, true); // Gets DTS/SCR/TOT text
  // console.log('getGoalsText', { match, competitionPhase, competitionPhaseRound, status, away, home, goals });

  switch (true) {
    case isLive(status) && Boolean(goals.TOT && goals.TOT.label):
      return `${goals.TOT!.label}: ${goals.TOT!.value}`;
    case isEndedAfterShootout(status) && Boolean(goals.DCR && goals.DCR.label):
      return `${goals.DCR!.label}: ${goals.DCR!.value}`;
    case isEndedAfterOverTime(status) && Boolean(goals.DTS && goals.DTS.label):
      return goals.DTS!.label ?? /* istanbul ignore next */ '';
    default:
      return '';
  }
};

export const getTeam = (name: string, logoUrl: string) => (
  <Team
    ellipsis
    name={name}
    logoUrl={logoUrl}
    colorSchema={DEFAULT_TEAM_COLOR_SCHEMA}
    iconPosition={DEFAULT_TEAM_ICON_POSITION}
    logoSize={DEFAULT_TEAM_LOGO_SIZE}
    fontSize={DEFAULT_TEAM_TEXT_FONT_SIZE}
    fontWeight={DEFAULT_TEAM_TEXT_FONT_WEIGHT}
  />
);
